/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { motion } from 'framer-motion';
class CommentDisplay extends Component {
  render() {
    const { username } = this.props;
    const { hoursOld } = this.props;
    const { comments } = this.props;
    const individualComments = comments.map((commentObj) => {
      return (
        <li key={commentObj.index}>
          <a href="#">{username}</a> {commentObj.comment}
        </li>
      );
    });
    const individualLikes = comments.map((commentObj) => {
      return (
        <li key={commentObj.index}>
          <button
            onClick={() => this.props.onCommentLike(commentObj.index)}
            className="like"
          >
            <motion.div
              animate={
                comments[commentObj.index].isLiked
                  ? { scale: [1, 1.29, 1] }
                  : { scale: [1, 1.3, 1] }
              }
              transition={{ duration: 0.4 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="13"
                height="13"
                viewBox="0 0 48 48"
                fill={comments[commentObj.index].isLiked ? '#ED4956' : 'white'}
                stroke={
                  comments[commentObj.index].isLiked ? '#ED4956' : 'black'
                }
                strokeWidth="5%"
              >
                <path d="M 15 7 C 8.9424416 7 4 11.942442 4 18 C 4 22.096154 7.0876448 25.952899 10.851562 29.908203 C 14.615481 33.863507 19.248379 37.869472 22.939453 41.560547 A 1.50015 1.50015 0 0 0 25.060547 41.560547 C 28.751621 37.869472 33.384518 33.863507 37.148438 29.908203 C 40.912356 25.952899 44 22.096154 44 18 C 44 11.942442 39.057558 7 33 7 C 29.523564 7 26.496821 8.8664883 24 12.037109 C 21.503179 8.8664883 18.476436 7 15 7 z"></path>
              </svg>
            </motion.div>
          </button>
        </li>
      );
    });

    return (
      <div className="comment-display">
        <div className="comment">
          <div className="comment-text">
            <ul>{individualComments}</ul>
          </div>
          <div className="comment-like">
            <ul>{individualLikes}</ul>
          </div>
        </div>
        <div className="post-age">
          <a href="#">
            {hoursOld > 1 ? hoursOld + ' HOURS' : hoursOld + ' HOUR'} AGO
          </a>
        </div>
      </div>
    );
  }
}

export default CommentDisplay;
